'use client';
import cn from 'classnames';

import './SideScrollElement.style.scss';

import { ReactNode } from 'react';

type SideScrollElementProps = {
  className?: string;
  children: ReactNode;
};

function SideScrollElement(props: SideScrollElementProps) {
  const { className = '', children } = props;

  return (
    <div className={cn('SideScrollElement', className)}>
      <div className={cn('SideScrollElement-items')}>{children}</div>
    </div>
  );
}

export default SideScrollElement;
